import { render, staticRenderFns } from "./ActivityFilterSidebar.vue?vue&type=template&id=54754b80&scoped=true"
import script from "./ActivityFilterSidebar.vue?vue&type=script&lang=js"
export * from "./ActivityFilterSidebar.vue?vue&type=script&lang=js"
import style0 from "./ActivityFilterSidebar.vue?vue&type=style&index=0&id=54754b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54754b80",
  null
  
)

export default component.exports